/**
 * Create a JSON Patch Document for SubmissionDetail updates
 * Follows RFC 6902 JSON Patch format for ASP.NET Core JsonPatchDocument
 *
 * @param {Object} updates - Object containing the fields to update
 * @returns {Array} Array of patch operations
 *
 * @example
 * const patchDoc = createSubmissionDetailPatchDocument({
 *   status: 1, // SubmissionDetailStatusEnum.Accepted
 *   description: "Updated description"
 * });
 * // Returns: [
 * //   { op: "replace", path: "/Status", value: 1 },
 * //   { op: "replace", path: "/Description", value: "Updated description" }
 * // ]
 */
export const createSubmissionDetailPatchDocument = updates => {
  const patchOperations = [];

  // Map of frontend field names to backend C# property names
  const fieldMapping = {
    description: 'Description',
    status: 'Status',
    criteriaTypeDetailId: 'CriteriaTypeDetail_Id',
    isChecked: 'IsChecked',
    value: 'Value',
  };

  Object.keys(updates).forEach(key => {
    const backendPath = fieldMapping[key] || key;
    const value = updates[key];

    if (value !== undefined) {
      patchOperations.push({
        op: 'replace',
        path: `/${backendPath}`,
        value: value,
      });
    }
  });

  return patchOperations;
};

export default {
  createSubmissionDetailPatchDocument,
};
